import { apiClient } from './client';

export interface FriendInfo {
  id: string;
  username: string;
  displayName: string;
  avatarUrl: string | null;
  status: string;
}

export interface FriendEntry {
  friendshipId: string;
  friend: FriendInfo;
}

export interface FriendRequest {
  id: string;
  senderId: string;
  receiverId: string;
  status: string;
  message: string | null;
  createdAt: string;
  updatedAt: string;
  sender: FriendInfo;
}

export interface OutgoingFriendRequest {
  id: string;
  senderId: string;
  receiverId: string;
  status: string;
  message: string | null;
  createdAt: string;
  updatedAt: string;
  receiver: FriendInfo;
}

export interface FriendshipStatus {
  status: string; // none, pending, accepted, rejected
  friendshipId: string | null;
  isSender?: boolean;
}

export const friendsApi = {
  async sendRequest(userId: string) {
    const res = await apiClient.post('/api/friends/request', { userId });
    return res.data;
  },

  async list() {
    const res = await apiClient.get<FriendEntry[]>('/api/friends');
    return res.data;
  },

  async listPending() {
    const res = await apiClient.get<FriendRequest[]>('/api/friends/pending');
    return res.data;
  },

  async listOutgoing() {
    const res = await apiClient.get<OutgoingFriendRequest[]>('/api/friends/outgoing');
    return res.data;
  },

  async getStatus(userId: string) {
    const res = await apiClient.get<FriendshipStatus>(`/api/friends/status/${userId}`);
    return res.data;
  },

  async accept(friendshipId: string) {
    const res = await apiClient.post(`/api/friends/${friendshipId}/accept`);
    return res.data;
  },

  async reject(friendshipId: string) {
    const res = await apiClient.post(`/api/friends/${friendshipId}/reject`);
    return res.data;
  },

  async cancel(friendshipId: string) {
    await apiClient.delete(`/api/friends/outgoing/${friendshipId}`);
  },

  async remove(friendshipId: string) {
    await apiClient.delete(`/api/friends/${friendshipId}`);
  },
};
